module.exports = __webpack_public_path__ + "static/media/saas.17dd4b84.svg";